<template>
	<div class="info-item">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>{{title}}</span>
		</div>
		<div class="form-box" v-if="form">
            <el-table :data="form" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column label="附件类型" prop="fjType" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column label="附件描述" prop="fjDescribe" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="endDate" label="文件到期日" :show-overflow-tooltip="true" width="120">
				</el-table-column>
				<el-table-column prop="lastUpdateTime" label="最后更新时间" :show-overflow-tooltip="true" width="120">
				</el-table-column>
				<el-table-column label="附件" width="95">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.src==undefined" type="info">无附件
						</el-tag>
						<el-link v-else :underline="false" :href="baseURL+scope.row.src" target="_blank">
							<el-tag type="success">查看附件</el-tag>
						</el-link>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-else class="no-info-box">请补充相关信息</div>
	</div>
</template>

<script>
	export default {
		name: "ShowBankInfo",
		computed: {
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		props:['title','form'],
		data() {
			return {
				imgHost:process.env.VUE_APP_BASE_API,
				tableData: [],
			};
		},
		mounted() {
		},
		methods: {
            formatIsMainNum: function(row) {
				return row.isMainNum == 0 ? '是' : '否';
			},
		}
	};
</script>
<style scoped="scoped">
</style>